export const CLOUD_FRONT_URL_SLUG = '[CLOUDFRONT_URL]/'